import React from 'react';
import PropTypes from 'prop-types';
import Styled from 'styled-components';
import {getDimensions, SIZE} from '../../utils/IntegrationIconSizer';

export const AdoIcon = ({size, onClick}) => {
	const dimensions = getDimensions(size);

	const handleClick = e => {
		/*
			We only want to stop propagation if onClick is set i props
			otherwise we want the click to propagate up
		*/
		if (onClick) {
			e.stopPropagation();
			onClick(e);
		}
	};

	return (
		<StyledSpan onClick={handleClick} width={dimensions} height={dimensions}>
			<svg
				id="f4337506-5d95-4e80-b7ca-68498c6e008e"
				xmlns="http://www.w3.org/2000/svg"
				width={dimensions}
				height={dimensions}
				viewBox="0 0 18 18"
			>
				<defs>
					<linearGradient
						id="ba420277-700e-42cc-9de9-5388a5c16e54"
						x1="9"
						y1="16.97"
						x2="9"
						y2="1.03"
						gradientUnits="userSpaceOnUse"
					>
						<stop offset="0" stopColor="#0078d4" />
						<stop offset="0.16" stopColor="#1380da" />
						<stop offset="0.53" stopColor="#3c91e5" />
						<stop offset="0.82" stopColor="#559cec" />
						<stop offset="1" stopColor="#5ea0ef" />
					</linearGradient>
				</defs>
				<title>Azure DevOps</title>
				<path
					id="a91f0ca4-8fb7-4019-9c09-0a52e2c05754"
					d="M17,4v9.74l-4,3.28-6.2-2.26V17L3.29,12.41l10.23.8V4.44Zm-3.41.49L7.85,1V3.29L2.58,4.84,1,6.87v4.61l2.26,1V6.57Z"
					fill="url(#ba420277-700e-42cc-9de9-5388a5c16e54)"
				/>
			</svg>
		</StyledSpan>
	);
};

AdoIcon.SIZE = SIZE;
AdoIcon.propTypes = {
	onClick: PropTypes.func,
	size: PropTypes.oneOf(Object.values(SIZE)),
};

const StyledSpan = Styled.div`
	display: inline;
	cursor: ${props => (props.onClick ? 'pointer' : 'default')};
	height: ${props => props.height + 'px'};
	width: ${props => props.width + 'px'};
`;
